import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DocumentosService } from '../../../services/documentos.service';

@Component({
  selector: 'app-visualizar-documentos',
  templateUrl: './visualizar-documentos.component.html',
  styleUrls: ['./visualizar-documentos.component.scss'],
})
export class VisualizarDocumentosComponent implements OnInit {
  tramiteId: string = '';
  documentos: Array<{ nombre: string; url: string }> = [];

  constructor(
    private route: ActivatedRoute,
    private documentosService: DocumentosService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];

      if (token) {
        try {
          const payload = this.decodificarToken(token);
          this.tramiteId = payload.tramiteId;
          console.log('TramiteId extraído del token:', this.tramiteId);
        } catch (error) {
          console.error('Error al decodificar token:', error);
          // Fallback: intentar obtener de query param
          this.tramiteId = params['id'] ?? '';
        }
      } else {
        // Flujo antiguo: obtener directamente del query param
        this.tramiteId = params['id'] ?? '';
      }

      if (this.tramiteId) {
        this.cargarDocumentos();
      }
    });
  }

  private decodificarToken(token: string): any {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = atob(base64);
    return JSON.parse(jsonPayload);
  }

  cargarDocumentos(): void {
    this.documentosService
      .obtenerDocumentosPorTramite(this.tramiteId)
      .subscribe({
        next: res => {
          this.documentos = res;
        },
        error: err => {
          console.error('Error al obtener los documentos:', err);
        },
      });
  }

  descargar(url: string): void {
    const link = document.createElement('a');
    link.href = url;
    link.download = '';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
